import { z } from "zod";

import { restPoster } from "~/api/fetchers";
import { zStringToJson } from "~/utilities/zodInputHelpers";

export const referralSchema = z.object({
  content: zStringToJson(),
  formId: z.number(),
  id: z.number(),
  patientId: z.number(),
});

export type Referral = z.infer<typeof referralSchema>;

const referralContentSchema = z.record(z.unknown()).transform(v => JSON.stringify(v));

const addReferralBodySchema = z.object({
  patientId: z.number(),
  formId: z.number(),
  content: referralContentSchema,
});

const updateReferralBodySchema = z.object({
  id: z.number(),
  patientId: z.number(),
  formId: z.number(),
  content: referralContentSchema,
});

export type AddReferralBody = z.input<typeof addReferralBodySchema>;
export type UpdateReferralBody = z.input<typeof updateReferralBodySchema>;
export type DeleteReferralBody = { id: number };

export const addReferralMutation = {
  mutationFn: async (body: AddReferralBody) => {
    const response = await restPoster<z.output<typeof addReferralBodySchema>, Referral>(
      "/v1/referral/add",
      addReferralBodySchema.parse(body)
    );
    return referralSchema.parse(response);
  },
};

export const updateReferralMutation = {
  mutationFn: async (body: UpdateReferralBody) => {
    const response = await restPoster<z.output<typeof updateReferralBodySchema>, Referral>(
      "/v1/referral/update",
      updateReferralBodySchema.parse(body)
    );
    return referralSchema.parse(response);
  },
};

export const deleteReferralMutation = {
  mutationFn: (body: DeleteReferralBody) =>
    restPoster<DeleteReferralBody, void>("/v1/referral/delete", body),
};
